import React from 'react'
import "./Footer.scss";

import Instagram from "../../images/instagram.svg"
import Facebook from "../../images/facebook.svg"
import LinkedIn from "../../images/linked-in.svg"
import Xtwitter from "../../images/x.svg"
import Whatsapp from "../../images/whatsapp.svg"
import Youtube from "../../images/youtube.svg"
import Logo from "../../images/mybyk-logo-footer.svg";
import PlayStore from "../../images/play-store-white.svg";
import AppStore from "../../images/app-store-white.svg";
import { useNavigate } from 'react-router-dom';

const Footer = () => {
    const navigate = useNavigate();
    const gotoHome = () => {
        navigate("/");
        window.scrollTo(0, 0);
    };
    return (
        <footer className='footer'>
            <div className="container">
                <div className="footer__nav">
                    <div className="footer__nav-wrap">
                        <div className="footer__nav-wrap-items">
                            <h3>MYBYK</h3>
                            <ul>
                                <li><a href="https://mybyk.in/assets/MYBYK-Brand-guidlines-Cme3OREn.pdf" target='_blank' rel='noreferrer' className='hover-ul'>Media Kit</a></li>
                            </ul>
                        </div>
                        <div className="footer__nav-wrap-items">
                            <h3>Legal</h3>
                            <ul>
                                <li><a href='https://mybyk.in/terms' target='_blank' rel='noreferrer' className='hover-ul'>Terms</a></li>
                                <li><a href='https://mybyk.in/privacy-policy' target='_blank' rel='noreferrer' className='hover-ul'>Privacy</a></li>
                            </ul>
                        </div>
                        <div className="footer__nav-wrap-items">
                            <h3>Get The App</h3>
                            <ul>
                                <li><a href="https://apps.apple.com/in/app/mybyk-pedal-ebike-rental/id1302751321" target='_blank' rel='noreferrer' aria-label='app store link'>
                                    <img src={AppStore} alt="app store download" loading='lazy' />
                                </a></li>
                                <li><a href="https://play.google.com/store/apps/details?id=in.greenpedia.mybyk&hl=en_IN" target='_blank' rel='noreferrer' aria-label='play store link'><img src={PlayStore} alt="" loading='lazy' /></a></li>
                            </ul>
                        </div>
                        <div className="footer__nav-wrap-items">
                            <h3>Stay Connected</h3>
                            <ul className='icons-link'>
                                <li ><a href="https://www.instagram.com/mybyk.in/?hl=en" target='_blank' rel='noreferrer' aria-label='instagram link'>
                                    <img src={Instagram} alt="instagram" loading='lazy' />
                                </a></li>
                                <li><a href="https://www.facebook.com/mybyk.in/" target='_blank' rel='noreferrer' aria-label='facebook link'>
                                    <img src={Facebook} alt="facebook" loading='lazy' />
                                </a></li>
                                <li><a href="https://www.linkedin.com/company/mybyk" target='_blank' rel='noreferrer' aria-label='linkedin link'>
                                    <img src={LinkedIn} alt="linkedin" loading='lazy' />
                                </a></li>
                                <li><a href="https://x.com/mybyk_in" target='_blank' rel='noreferrer' aria-label='twitter link'>
                                    <img src={Xtwitter} alt="twitter" loading='lazy' />
                                </a></li>
                                <li><a href="https://wa.me/7043987987" aria-label='whatsapp chat link' target='_blank' rel='noreferrer'>
                                    <img src={Whatsapp} alt="whatsapp chat" loading='lazy' />
                                </a></li>
                                <li><a href="https://www.youtube.com/@mybykindia" target='_blank' rel='noreferrer' aria-label='youtube link'>
                                    <img src={Youtube} alt="youtube" loading='lazy' />
                                </a></li>
                            </ul>
                        </div>
                    </div>

                    <div className="footer__nav-logo-copy">
                        <div className="logo">
                            <button onClick={gotoHome} aria-label='go to home'>
                                <img src={Logo} alt="logo" loading='lazy' />
                            </button>
                        </div>
                        <div className="copy">
                            <span>CIN: U74900GJ2013PTC077927</span>
                            <p>© <b>{new Date().getFullYear()}</b>&nbsp;MYBYK. All rights reserved.</p>
                            <p className='powered-by'>Powered by <a href="https://equestsolutions.net/" target='_blank' rel='noreferrer'>eQuest Solutions</a></p>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    )
}
export default Footer;